import React from 'react';
import './App.css';

function ScrollProgress(props: any) {

  return (
    <div className="scrollContainer" >
      <div ref={props.ref} className="progressBar" id="myBar"></div>
    </div>
  );
}

export default ScrollProgress;
